import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-vestiging-card',
  templateUrl: './vestiging-card.component.html',
  styleUrls: ['./vestiging-card.component.sass']
})
export class VestigingCardComponent implements OnInit {

  @Input() vestiging:any = {};
  @Input() details:Boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
